function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useContext, useEffect, useState } from 'react';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import Paper from '@material-ui/core/Paper';
import Popover from '@material-ui/core/Popover';
import Chip from '@material-ui/core/Chip';
import { makeStyles } from '@material-ui/styles';
import { LocaleContext } from '@tecsinapse/ui-kit';
var styles = makeStyles(function (theme) {
  return {
    container: {
      padding: theme.spacing(1),
      display: 'flex',
      flexWrap: 'wrap',
      backgroundColor: '#F7F7F7'
    },
    title: {
      color: theme.palette.text.secondary,
      fontSize: '0.8rem',
      paddingTop: '6px'
    },
    card: {
      marginLeft: theme.spacing(1),
      padding: '5px'
    }
  };
});
var cardStyles = makeStyles(function (theme) {
  return {
    card: {
      marginLeft: theme.spacing(1),
      padding: '5px',
      cursor: 'pointer'
    },
    popover: {
      display: 'flex',
      flexWrap: 'wrap',
      maxWidth: '300px',
      justifyContent: 'space-evenly'
    },
    chipContainer: {
      padding: '3px'
    },
    chip: {
      fontWeight: '500'
    }
  };
});

var CardFilter = function CardFilter(_ref) {
  var title = _ref.title,
      selectedValues = _ref.selectedValues,
      _onDelete = _ref.onDelete;
  var classes = cardStyles();

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      anchorEl = _useState2[0],
      setAnchorEl = _useState2[1];

  var open = Boolean(anchorEl);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Paper, {
    className: classes.card,
    onClick: function onClick(event) {
      return setAnchorEl(event.currentTarget);
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2"
  }, title)), /*#__PURE__*/React.createElement(Popover, {
    open: open,
    anchorEl: anchorEl,
    onClose: function onClose() {
      return setAnchorEl(null);
    },
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'center'
    },
    transformOrigin: {
      vertical: 'bottom',
      horizontal: 'center'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.popover
  }, selectedValues.map(function (value, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: value,
      className: classes.chipContainer
    }, /*#__PURE__*/React.createElement(Chip, {
      label: "".concat(value),
      className: classes.chip,
      onDelete: function onDelete() {
        _onDelete(index);

        setAnchorEl(false);
      }
    }));
  }))));
};

var onApplyAdvFilter = function onApplyAdvFilter(setFilters) {
  return function (filters) {
    setFilters(function (prevFilters) {
      return _objectSpread(_objectSpread(_objectSpread({}, prevFilters), filters), {}, {
        page: 0,
        startIndex: 0,
        stopIndex: filters.rowsPerPage - 1
      });
    });
  };
};

var checkTypeAndApply = function checkTypeAndApply(setFilters, filters, name, i) {
  var type = _typeof(filters.advancedFilters[name]);

  if (type === 'string') {
    // eslint-disable-next-line no-param-reassign
    filters.advancedFilters[name] = '';
  } else if (type === 'boolean') {
    // eslint-disable-next-line no-param-reassign
    filters.advancedFilters[name] = !filters.advancedFilters[name];
  } else {
    filters.advancedFilters[name].splice(i, 1);
  }

  onApplyAdvFilter(setFilters)(filters);
};

var filterOptions = function filterOptions(options, value) {
  if (options && options.length > 0 && value && value.length > 0) {
    return options.filter(function (option) {
      return value.indexOf(option.value) > -1;
    }).map(function (option) {
      return option.label;
    });
  }

  return value;
};

var SelectedFilters = function SelectedFilters(_ref2) {
  var advancedFilters = _ref2.advancedFilters,
      filters = _ref2.filters,
      setFilters = _ref2.setFilters;

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      filtersSelected = _useState4[0],
      setFiltersSelected = _useState4[1];

  useEffect(function () {
    if (!advancedFilters) {
      return [];
    }

    var selectedFilters = advancedFilters.filters.filter(function (_ref3) {
      var name = _ref3.name,
          options = _ref3.options;
      var value = filterOptions(options, filters.advancedFilters[name]);
      return value && value.length > 0 || value && typeof value === 'boolean';
    }).map(function (_ref4) {
      var name = _ref4.name,
          label = _ref4.label,
          options = _ref4.options;
      var value = filterOptions(options, filters.advancedFilters[name]);
      return {
        name: name,
        label: label,
        values: Array.isArray(value) ? value : [value]
      };
    });
    setFiltersSelected(selectedFilters);
    return undefined; // Returning undefined due to React warning on console
  }, [advancedFilters, filters]); // eslint-disable-line react-hooks/exhaustive-deps

  var classes = styles();

  var _useContext = useContext(LocaleContext),
      selectedFiltersLabel = _useContext.Table.selectedFiltersLabel;

  if (filtersSelected.length === 0) {
    return null;
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2",
    className: classes.title
  }, selectedFiltersLabel, ":"), filtersSelected.map(function (_ref5) {
    var name = _ref5.name,
        label = _ref5.label,
        values = _ref5.values;
    return /*#__PURE__*/React.createElement(CardFilter, {
      key: name,
      title: label,
      selectedValues: values,
      onDelete: function onDelete(i) {
        checkTypeAndApply(setFilters, filters, name, i);
      }
    });
  })), /*#__PURE__*/React.createElement(Divider, null));
};

export default SelectedFilters;